export const HS_PLUGINS = 'hsPlugins';
export const HS_INPAGE_SETTINGS = 'hsInpage';
export const HS_NO_SUBSCRIPTION = 'hsNoSubscriptionLinks';